import download from 'downloadjs';

export class Context {
  constructor(getStates) {
    this.getStates = getStates;
  }
}

export const create = {
  attender: (
    rowid = -2,
    active = true,
    birthdate = 0,
    email = '',
    name = '',
    note = '',
    picture256 = '',
    phone = '',
  ) => {
    return {
      active,
      birthdate,
      email,
      name,
      note,
      phone,
      picture256,
      rowid,
    }
  },
  attendersFilter: (
    attending = true,
    keywords = '',
    noUsableTickets = false,
    notAttending = false,
    orderBy = '',
    zeroPaid = false,
  ) => {
    return {attending, keywords, noUsableTickets, notAttending, orderBy, zeroPaid}
  },
  attending: (attenderRowid, attenderName, attenderPicture64, lastAttended) => {
    return {attenderRowid, attenderName, attenderPicture64, lastAttended};
  },
  birthdate: (rowid = -1, birthdate = 0) => {
    return {rowid, birthdate};
  },
  issuedTicket: (provided = {}) => {
    return {
      activeFrom: 0,
      activeUntil: 0,
      color: '#000000',
      name: '',
      note: '',
      paidMethod: '',
      rowid: -1,
      usable: true,
      usedAt: 0,
      ...provided,
    };
  },
  email: (rowid = -1, email = '') => {
    return {rowid, email};
  },
  name: (rowid = -1, name = '') => {
    return {rowid, name};
  },
  note: (rowid = -1, note = '') => {
    return {rowid, note};
  },
  payment: (rowid = -2) => {
    return {
      amount: 0,
      currency: '원',
      date: Date.now(),
      issued: [],
      method: '미결제',
      note: '',
      rowid,
    };
  },
  picture: (
    attenderRowid = -1,
  ) => {
    return {attenderRowid};
  },
  phone: (rowid = -1, phone = '') => {
    return {rowid, phone};
  },
  quickAttending: (
    rowid = -1,
    date = Date.now(),
    note = '',
    picture256 = '',
  ) => {
    return {
      date,
      note,
      picture256,
      rowid,
    };
  },
  schedule: (
    rowid = -2,  // -1 for new
    attendings = [],
    day = 1,  // 0 ~ 6
    name = '',
    note = '',
    secondsFrom = 0,
    secondsTo = 0,
  ) => {
    return {
      rowid,
      attendings,
      day,
      name,
      note,
      secondsFrom,
      secondsTo,
    };
  },
  ticket: (provided = {}) => {
    return {
      activeFrom: Date.now(),
      activeUntil: Date.now(),
      color: '#000000',
      issuable: true,
      name: '',
      note: '',
      rowid: -2,  // -1 for new

      changingColor: false,
      deletable: false,

      ...provided,
    };
  },
};

export const date = {
  HHmm: (seconds) => {
    const HH = ('0' + Math.floor(seconds / 3600)).slice(-2); seconds = seconds % 3600;
    const mm = ('0' + Math.floor(seconds / 60)  ).slice(-2); seconds = seconds % 60;
    return `${HH}:${mm}`;
  },
  used: (timestamp) => {
    if (timestamp === null) {
      return '-';
    }
    const date = new Date(timestamp);

    const yyyy = date.getFullYear();
    const MM = ('0' + (date.getMonth() + 1)).slice(-2);
    const dd = ('0' + date.getDate()       ).slice(-2);
    const day = '일월화수목금토'[date.getDay()];
    const HH = ('0' + date.getHours()      ).slice(-2);
    const mm = ('0' + date.getMinutes()    ).slice(-2);

    return `${yyyy}.${MM}.${dd} (${day}요일) ${HH}:${mm}`;
  },
  withDay: (timestamp) => {
    const date = new Date(timestamp);

    const yyyy = date.getFullYear();
    const MM = ('0' + (date.getMonth() + 1)).slice(-2);
    const dd = ('0' + date.getDate()       ).slice(-2);
    const day = '일월화수목금토'[date.getDay()];

    return `${yyyy}.${MM}.${dd} (${day}요일)`;
  },
  withoutTime: (timestamp) => {
    if (timestamp) {
      const date = new Date(timestamp);
      const yyyy = date.getFullYear();
      const MM = ('0' + (date.getMonth() + 1)).slice(-2);
      const dd = ('0' + date.getDate()       ).slice(-2);
      return `${yyyy}.${MM}.${dd}`;
    } else {
      return '';
    }
  },
};

export class Request {
  constructor(token, setToken) {
    this.token = token;
    this.setToken = setToken;
  }

  postSecurely = async (path, body, callback, filename = '.json', accessToken = undefined) => {
    const fetched = fetch(`${process.env.REACT_APP_API_URL}${path}`, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + (accessToken ? accessToken : this.token.access),
      },
      body: JSON.stringify(body),
    });

    if (filename === '.json') {
      fetched.then((response) => {
        if (response.status === 401) {
          throw new Error('401');
        }
        return response.json();
      }).then(callback).catch((error) => {
        if (error.message === '401') {
          this.postSecurelyRefreshed(path, body, callback, filename);
        } else {
          console.error(error);
        }
      });
    } else if (filename.endsWith('.xlsx')) {
      fetched.then((response) => {
        if (response.status === 401) {
          throw new Error('401');
        }
        return response.blob();
      }).then((response) => {
        download(response, filename, 'application/vnd.ms-excel');
      }).catch((error) => {
        if (error.message === '401') {
          this.postSecurelyRefreshed(path, body, callback, filename);
        } else {
          console.error(error);
        }
      });
    }
  }

  postSecurelyRefreshed = async (path, body, callback, filename = '.json') => {
    fetch(`${process.env.REACT_APP_API_URL}/token/refresh`, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + this.token.refresh,
      },
    }).then(response => response.json()).then(response => {
      this.postSecurely(path, body, callback, filename, response.access_token);
      this.setToken({
        access: response.access_token,
        refresh: response.refresh_token,
      });
    });
  }
}

export const post = {
  forToken: async (body = {}) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/token`, {
      method: 'POST',
      body,
    });
    return response.json();
  },
};

export const selectable = {
  payCurrencies: [
    {'label': '원', 'value': '원'},
    {'label': '달러', 'value': '달러'},
  ],
  payMethods:[
    {'label': '미결제', 'value': '미결제'},
    {'label': '현금', 'value': '현금'},
    {'label': '카드', 'value': '카드'},
    {'label': '성남사랑상품권', 'value': '성남사랑상품권'},
  ],
};

export function countByTicket(issued) {
  let counted = [];
  let index = {};
  for (const ticket of issued) {
    if (!(ticket['ticket_rowid'] in index)) {
      index[ticket['ticket_rowid']] = counted.length;
      counted.push([ticket['ticket_rowid'], 0]);
    }
    counted[index[ticket['ticket_rowid']]][1]++;
  }
  return counted;
}